// export enum Distributors {
//   None,
//   ISim,
//   Corpuls,
// }
export const Distributors = {
  none: 1,
  isimulate: 2,
  corpuls: 3,
};

export function loadDistributor() {
  if (location.host.includes("isimulate.community")) {
    return Distributors.isimulate;
  } else if (location.host.includes("corpulssimulation.com")) {
    return Distributors.corpuls;
  } else {
    return Distributors.none;
  }
}

export const ProductList = {
  REALITI: "REALITi",
  ALSI: "ALSi",
};

export const validateProductName = product => {
  const productLowercase = product.toLowerCase();
  if (productLowercase === ProductList.REALITI.toLowerCase()) {
    return ProductList.REALITI;
  }

  if (productLowercase === ProductList.ALSI.toLowerCase()) {
    return ProductList.ALSI;
  }
};
